import { user } from '@lobby/store/user';
import { of } from 'rxjs';

export default function handleCurrentBalance(socketMessage) {
  const { balance } = socketMessage;
  return of(
    // Update user balance
    user.update({
      balance,
    })
  );
}
